import React, { useEffect, useState } from "react";
import { Form, Row, Col, Select, Button, Spin, Space } from "antd";
import { Notification } from "components/common";
import { pharmacyStoreService } from "api";
import { FORMAT_TIME } from "types/enums";
import { formatDate, formatDateDelete } from "helper/common";

const { Option } = Select;

const DeleteContent = ({ closeModal, nameCatalog,refreshData,getListBidDecision  }) => {
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchNgayImport();
  }, [refreshData]);

  const fetchNgayImport = async () => {
    setLoading(true);
    try {
      const response = await pharmacyStoreService.getNgayImport();
      const dates = response.data;
      if (Array.isArray(dates)) {
        setItems(dates.map(date => ({ label: date, value: date }))); 
      } else {
        throw new Error("Data is not an array");
      }
    } catch (error) {
      Notification("error", "Không thể lấy dữ liệu từ server");
    } finally {
      setLoading(false);
    }
  };

  const onFormSubmit = async () => {
    setLoading(true);
    try {
      const dateToBeDeleted = selectedItem;
      if (dateToBeDeleted) {
        await pharmacyStoreService.deleteNgayImport({ ngayImport: dateToBeDeleted });
        Notification("success", `Đã xóa ${nameCatalog} đã chọn.`);
        // Refresh the list of dates
        await fetchNgayImport();
        await getListBidDecision();
      } else {
        Notification("error", `Vui lòng chọn ${nameCatalog} để xóa.`);
      }
    } catch (error) {
      Notification("error", error?.response?.data?.message ?? `Đã có lỗi khi xóa ${nameCatalog}`);
    } finally {
      setLoading(false);
      closeModal();
    }
  };

  return (
    <Spin spinning={loading}>
      <Form onFinish={onFormSubmit}>
        <Row>
          <Col span={24}>
            <Select
              style={{ width: '100%' }}
              placeholder="Chọn ngày"
              value={selectedItem}
              onChange={value => setSelectedItem(value)}
            >
              {items.map(item => (
                <Option key={item.value} value={item.value}>
                  {formatDateDelete(item.label)}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        <Row justify="end" style={{ marginTop: '8px' }}>
          <Col>
            <Space>
              <Button onClick={closeModal}>Hủy</Button>
              <Button htmlType="submit" type="primary">
                Xác nhận
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default DeleteContent;
